export default __webpack_public_path__ + "static/Face3-6d2487487888f740522ac7308adad69b.jpg";